module.exports = __webpack_public_path__ + "static/media/history.041ff0d4.svg";